import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { formatNumberBasedOnValue } from "@/lib/globalFormatterHelper";

// Fee-adjusted yield tooltip: skipped when the cell's own notation is already Yield (values would match).
export function feeAdjustedYieldTooltipValueGetter(params: any) {
  const { data, isER, isLeg, isOutright } =
    returnAllTradeDetailsFromGenericParams(params);

  let value = null;
  let notationIsYield = false;

  if (isER && isOutright) {
    value = data.legs?.[0]?.feeAdjustedYield;
    notationIsYield = data.legs?.[0]?.notation == "%";
  } else if (isER || isLeg) {
    value = data.feeAdjustedYield;
    notationIsYield = isER ? data.notationER == "%" : data.notation == "%";
  } else {
    return;
  }

  if (value == null) return; // no fee-adjusted yield to show
  if (notationIsYield) return; // cell already shows Yield, values are the same

  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) return;
  if (numericValue == 0) return;

  const numberOfDecimalPlaces = formatNumberBasedOnValue("%");
  return `${parseFloat(numericValue.toFixed(numberOfDecimalPlaces))} %`;
}
